// extracted by mini-css-extract-plugin
module.exports = {"colorBlueElectric":"#3668ff","colorCyan":"#00a0ee"};